export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  home: {
    home: "/dashboards",
  },
  contact: {
    contact: "/contact",
  },
  contactPage: {
    contactPage: "/contact-page",
  },
  faq: {
    faq: "/faq",
    addFaq: "/faq/create",
  },
  testimonial: {
    testimonial: "/testimonials",
    addTestimonial: "/testimonials/create",
  },

  projects: {
    projects: "/projects",
    addProjects: "/projects/create",
  },
  website: {
    website: "/website-management",
    addWebsite: "/website-management/create",
  },
  categories: {
    categories: "/categories",
    addCategories: "/categories/create",
  },
  client: {
    client: "/client",
    logs: "/logs",
    createClient: "/client/create",
  },

  settings: {
    settings: "/settings",
    createSettings: "/settings/create",
  },

  admins: {
    admins: "/admins",
    addAdmins: "/admins/create",
  },
  privileges: {
    addPrivileges: "/privileges/create",
    privileges: "/privileges",
  },
};
